import { FilterKeys } from '../../../constants';

export const formatValue = (key: string, value: string) => {
  if (key === FilterKeys.START_DATE || key === FilterKeys.END_DATE) {
    return new Date(value).toLocaleDateString();
  }
  return value;
};
